import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { ErrorBoundary } from "./ErrorBoundary";
import { warnMissingClientEnv } from "./lib/env";

function BootProbe() {
  React.useEffect(() => { warnMissingClientEnv(); }, []);
  return null;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
        <BootProbe />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
